import axios from 'axios';
import { ApiKeyResult } from '../models/apiKeyResult';
import Service from './service';

/**
 * APIキーAPIを操作するクラスです。
 */
class ApiKeyService extends Service {
    /**
     * APIキーの取得を行います。
     * @returns 取得したAPIキーを返します。
     */
    public async getApiKey() {
        const apiEndpoint = this.createApiEndpoint('read-api-keys');
        const jwt = sessionStorage.getItem('jwt');
        let result: ApiKeyResult | null = null;

        const response = await axios.get(apiEndpoint, {
            params: {
                jwt_str: jwt
            }
        });

        if (response.status === 200) {
            result = response.data as ApiKeyResult;
        }

        return result;
    }

    /**
     * APIキーの更新を行います。
     * @returns 更新したAPIキーを返します。
     */
    public async updateApiKey() {
        const apiEndpoint = this.createApiEndpoint('update-api-keys');
        const jwt = sessionStorage.getItem('jwt');
        let result: ApiKeyResult | null = null;

        const response = await axios.get(apiEndpoint, {
            params: {
                jwt_str: jwt
            }
        });

        if (response.status === 200) {
            result = await this.getApiKey();
        }

        return result;
    }
}

export default ApiKeyService;